import { ListItemIcon } from '@mui/material';
import { styled } from '@mui/material/styles';
import isBoolean from 'lodash/isBoolean';

import { NAVIGATION_ITEM_VARIANT_MAP } from 'layout/MainLayout/components/Sidebar/constants';
import { SidebarStateKey } from 'layout/MainLayout/components/Sidebar/store';
import { NavigationItemStateKey } from 'layout/MainLayout/components/Sidebar/types';

import type { Theme } from '@mui/material';
import type {
  SidebarAnimatedComponentsState,
  NavigationItemState,
  NavigationItem,
} from 'layout/MainLayout/components/Sidebar/types';

type NavigationItemProps = SidebarAnimatedComponentsState &
  NavigationItemState &
  Pick<NavigationItem, 'sidebarType' | 'disabled'>;

const getColor = (
  theme: Theme,
  { isActive, opened, sidebarType, disabled }: NavigationItemProps,
) => {
  if (isActive && isBoolean(opened) && !opened) {
    return theme.palette[NAVIGATION_ITEM_VARIANT_MAP[sidebarType]].main;
  }

  if (isActive) {
    return theme.palette[NAVIGATION_ITEM_VARIANT_MAP[sidebarType]].dark;
  }

  if (disabled) {
    return theme.palette.action.disabled;
  }

  return theme.palette.action.active;
};

export const NavigationItemIcon = styled(ListItemIcon, {
  shouldForwardProp: prop =>
    prop !== NavigationItemStateKey.IsActive &&
    prop !== SidebarStateKey.Opened &&
    prop !== 'sidebarType' &&
    prop !== 'disabled',
})<NavigationItemProps>(
  ({ isActive, opened, sidebarType, theme, disabled }) => ({
    minWidth: 38,
    color: getColor(theme, { isActive, opened, sidebarType, disabled }),
  }),
);
